export interface PageHealth { visible: boolean; delayMilliseconds: number }
export function browserHighsWorkerCount(hardwareConcurrency = globalThis.navigator?.hardwareConcurrency): number {
  return Number.isFinite(hardwareConcurrency) ? Math.max(1, Math.floor(hardwareConcurrency!) - 1) : 1;
}
export function browserMemoryBudget(deviceMemory?: number): number {
  return Number.isFinite(deviceMemory) && deviceMemory! > 0 ? deviceMemory! * 1024 ** 3 * 0.25 : 512 * 1024 ** 2;
}
/** Five-second foreground windows; grows slowly and backs off with hysteresis. */
export class AdaptiveBudget {
  private samples: number[] = [];
  private slowWindows = 0;
  private cooldownUntil = 0;
  private lastSampleAt = -Infinity;
  private windowStartedAt: number | undefined;
  sample(health: PageHealth, now: number): 'grow' | 'shrink' | 'hold' {
    if (!health.visible || !Number.isFinite(health.delayMilliseconds)) { this.samples = []; this.windowStartedAt = undefined; this.slowWindows = 0; this.lastSampleAt = now; return 'hold'; }
    if (now - this.lastSampleAt < 900) return 'hold';
    this.windowStartedAt ??= now - 1000;
    this.lastSampleAt = now;
    this.samples.push(Math.max(0, health.delayMilliseconds));
    if (now - this.windowStartedAt < 5000) return 'hold';
    const ordered = this.samples.sort((a, b) => a - b);
    const p95 = ordered[Math.ceil(ordered.length * 0.95) - 1]!;
    this.samples = [];
    this.windowStartedAt = now;
    this.slowWindows = p95 > 100 ? this.slowWindows + 1 : 0;
    if (this.slowWindows >= 2) { this.slowWindows = 0; this.cooldownUntil = now + 10_000; return 'shrink'; }
    return p95 < 50 && now >= this.cooldownUntil ? 'grow' : 'hold';
  }
  memoryPressure(now: number): void { this.cooldownUntil = now + 10_000; this.samples = []; this.windowStartedAt = undefined; }
}
